import React, {Component} from "react";
import {format2NiceDate} from "../utils/DateUtils";
import Paper from "@material-ui/core/Paper/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import Card from "react-bootstrap/Card";
import {CSVLink} from "react-csv";
import {getFormattedDate} from "../orders/OrdersExporter";
import {FaFileExport} from "react-icons/fa";
import {getIdFromUrl} from "../utils/MiscellaniousUtils";
import ResourceAPIs from "../utils/ResourceAPI";

class InventoryReportContents extends Component {

    constructor(props) {
        super(props);

        this.state = {
            breport: this.props.breport,
            contents: [],
            isLoaded: false,
            deleteBtnText: "Delete",
            isProcessing: false,
        };
    }

    getContents = () => {
        new ResourceAPIs().getInventoryReportContentsById(getIdFromUrl())
            .then(res => {
                    const result = res.data;
                    this.setState({
                        contents: this.addBReportData(result),
                        isLoaded: true,
                    });

                })
            .catch(error => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            );
    };

    addBReportData = (arr) => {
        for (let i = 0; i < arr.length; i++) {
            arr[i].inventoryReportId = this.state.breport.id;
            arr[i].clientId = this.state.breport.clientId;
            arr[i].storeName = this.state.breport.storeName;
            arr[i].date = this.state.breport.date;
        }
        return arr;
    };

    componentDidMount() {
        this.getContents();
    }

    componentWillReceiveProps({someProp}) {
        if (this.props.isLoad) {
            this.getContents();
        }
    }

    render() {
        if (!this.state.isLoaded) {
            return <p>Loading...</p>
        } else {
            return (
                <div>
                    <Card border="secondary">
                        <Card.Header as="h5">
                            <span style={{marginTop: 20}}>Inventory Report Contents</span>
                            <CSVLink data={this.state.contents}
                                     filename={"inventory-report-contents-export-" + getFormattedDate(new Date()) + ".csv"}
                                     className="btn btn-primary small"
                                     style={{float: "right"}}>
                                <FaFileExport/> Export
                            </CSVLink>
                        </Card.Header>
                        <Card.Body>
                            <TableContainer component={Paper}>
                                <Table aria-label="simple table" size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Content ID</TableCell>
                                            <TableCell align="center">SKU</TableCell>
                                            <TableCell align="center">FNSKU</TableCell>
                                            <TableCell align="center">ASIN</TableCell>
                                            <TableCell align="center">Product Name</TableCell>
                                            <TableCell align="center">Condition</TableCell>
                                            <TableCell align="center">Your Price</TableCell>
                                            <TableCell align="center">Created At</TableCell>
                                            <TableCell align="center">Updated At</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.contents.map((row, index) => (
                                            <TableRow key={row.id}>
                                                <TableCell align="right">{row.id}</TableCell>
                                                <TableCell align="left">{row.sku}</TableCell>
                                                <TableCell align="left">{row.fnsku}</TableCell>
                                                <TableCell align="left">{row.asin}</TableCell>
                                                <TableCell align="left">{row.productName}</TableCell>
                                                <TableCell align="left">{row.condition}</TableCell>
                                                <TableCell align="right">{row.yourPrice}</TableCell>
                                                <TableCell align="right">
                                                    {format2NiceDate(row.createdAt)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {format2NiceDate(row.updatedAt)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Card.Body>
                    </Card>
                </div>
            );
        }
    }
}

export default InventoryReportContents;
